<template>
    <div>
    <!--  User {{ $route }} with post {{ $route.params.postId }} -->
    </div>
  </template>